<template>
  <div class="default-modal alert-modal">
    <div class="default-modal__header">
      <h3 class="default-modal__title" v-if="title">{{ title }}</h3>
      <button type="button" class="default-modal__close" @click="$emit('close')">
        <IconComponent name="close-square" />
      </button>
    </div>
    <div class="default-modal__body">
      <div class="alert-modal__message">
        {{ message || "Успешно!" }}
      </div>
    </div>
    <div class="default-modal__footer alert-modal__footer">
      <button type="button" class="btn btn--md btn--gray" @click="$emit('closeAll')">Закрыть</button>
      <button v-if="isConfirm" @click="confirm" type="button" class="btn btn--md btn--main alert-modal__btn">
        {{ confirmBtnTitle }}
      </button>
    </div>
  </div>
</template>

<script>
import IconComponent from "components/IconComponent.vue";

export default {
  name: "AlertModal",
  props: {
    title: String,
    message: String,
    isConfirm: Boolean,
    confirmBtnTitle: {
      type: String,
      default: "Да",
    },
    callback: Function,
  },
  methods: {
    confirm() {
      if (this.callback) {
        this.callback();
      }
      this.$emit("close");
    },
  },
  components: { IconComponent },
};
</script>

<style lang="stylus">
.alert-modal {
  width 100%
  max-width 382px

  &__message {
    text-align center
    width 100%
  }

	& &__footer {
		width 100%
		display flex
		flex-wrap wrap
		flex-direction row
		align-items center
		justify-content center
		gap 10px
		margin-top 10px

		.btn {
			flex 1
		}
	}
}
</style>
